import { useBreakpoints } from '@vueuse/core';
import { breakpoints as definedBreakpoints } from '@/styling/foundation/breakpoint';

export const breakpoints = useBreakpoints(definedBreakpoints);

export const isMobile = breakpoints.smaller('lg');
export const isSmallerThanXl = breakpoints.smaller('xl');
export const isSmallerThanMd = breakpoints.smaller('md');
